import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router';
import { CLEAR_USER, SET_USER } from '../../store/model/user';
import { SET_ACCOUNT_SERVICE_INFO } from '../../store/model/accountService';
import { fetchPostApi, getCookie } from '../../utils/api';
import { BASE_URL } from '../../utils/constants';
import { setLoginUserInfo } from '../../utils/tools';
import Loading from '../loading/Loading';
import channel from '../../Broadcast';
import { ensurePaymentOperatorSession } from '../../utils/payment_api';
import { fetchTossOnboardingStatus } from '../../utils/toss_onboarding_api';
interface LayoutAuthProps {
  onSubmit: () => void;
}

const LayoutAuth = (props: LayoutAuthProps) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const onSubmit = props.onSubmit;

  const loadTossOnboardingStatus = async (payload: UserType) => {
    if (!payload.pass || !payload.cid || !payload.uid || payload.memtype === 'F') {
      return;
    }

    try {
      const paymentSessionReady = await ensurePaymentOperatorSession(payload.uid);

      if (!paymentSessionReady) {
        throw new Error('PAYMENT_OPERATOR_SESSION_FAILED');
      }

      const statusPayload = await fetchTossOnboardingStatus(payload.cid, payload.uid);
      dispatch({
        type: SET_ACCOUNT_SERVICE_INFO,
        payload: statusPayload,
      });
    } catch (error) {
      console.log('toss_onboarding_status_error', error);
      dispatch({
        type: SET_ACCOUNT_SERVICE_INFO,
        payload: {
          onboardingLoaded: true,
          onboardingError: 'STATUS_FAILED',
        },
      });
    }
  };

  useEffect(() => {
    if (window.location.pathname.replace('/admin', '') == '/auth') {
      window.addEventListener('message', parentReceiveMessage);
    } else {
      authUser();
    }

    return () => {
      window.addEventListener('message', parentReceiveMessage);
    };
  }, []);

  function parentReceiveMessage(event: MessageEvent) {
    // if (event.origin !== 'http://localhost:8080' && event.message !== 'iframe is ready') {
    //   return;
    // }
    if (
      [
        'http://49.236.145.134',
        'https://checkbus.co.kr',
        'http://checkbus.co.kr',
        'http://www.checkbus.co.kr',
        'https://www.checkbus.co.kr',
        'http://checkbus.irontrain.co.kr',
        'https://checkbus.irontrain.co.kr',
        'http://admin.checkbus.co.kr',
        'https://admin.checkbus.co.kr',
      ].includes(event.origin)
    ) {
      const { v2_id, v2_pwd } = event.data;
      if (v2_id && v2_pwd) {
        window.opener.focus();
        window.opener.close();
        window.opener.postMessage('opened', '*');
        window.addEventListener('message', parentReceiveMessage);

        autoLogin(v2_id, v2_pwd, location.pathname.replace('/admin', ''));
      }
    }
  }

  const autoLogin = async (id: string, pw: string, path: string) => {
    document.cookie = `a-token=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;`;
    if (channel) {
      channel.postMessage({
        type: 'logout',
      });
    }
    dispatch({
      type: CLEAR_USER,
    });
    sessionStorage.removeItem('user');
    let cur_id = id;
    let cur_pw = pw;
    if (path == '/pretest') {
      cur_id = 'pretest';
      cur_pw = '1234';
      const query = location.href.replace('/admin', '').split('?')[1]
        ? location.href.replace('/admin', '').split('?')[1].split('&')
        : [];
      const phone = query.find(item => item.includes('phone'));
      if (phone) {
        const phone_num = phone.replace(/phone=/gi, '');

        if (phone_num) {
          localStorage.setItem('pretest_phone', `${phone_num}`);
        }
      }
    }

    const login_res = await fetchPostApi('/login', {
      id: cur_id,
      pw: cur_pw,
    });

    if (login_res.pass) {
      const payload = setLoginUserInfo(login_res.message);
      sessionStorage.setItem('user', JSON.stringify(payload));
      dispatch({
        type: SET_USER,
        payload,
      });
      void loadTossOnboardingStatus(payload);

      if (['/pretest', '/auth'].includes(path)) {
        navigate(`${BASE_URL}/`);
      }
    } else {
      document.cookie = `a-token=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;`;
      if (channel) {
        channel.postMessage({
          type: 'logout',
        });
      }
    }

    onSubmit();
    return;
  };

  const authUser = async () => {
    if (['/pretest', '/auth'].includes(location.pathname.replace('/admin', ''))) {
      autoLogin('', '', location.pathname.replace('/admin', ''));
    } else {
      let auto = true;
      if (
        location.href.replace('/admin', '').includes('login') &&
        location.href.replace('/admin', '').includes('auto')
      ) {
        const query = location.href.replace('/admin', '').split('?')[1].split('&');

        const auto_login = query.find(item => item.includes('auto='));
        if (auto_login && auto_login.includes('false')) {
          document.cookie = `a-token=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;`;
          if (channel) {
            channel.postMessage({
              type: 'logout',
            });
          }
          sessionStorage.removeItem('user');
          navigate(`${BASE_URL}/login`);

          auto = false;
        }
      }

      const a_token = getCookie('a-token');

      if (a_token && auto) {
        const login_res = await fetchPostApi('/login/remain', {});
        if (login_res.pass) {
          const payload = setLoginUserInfo(login_res.message);
          sessionStorage.setItem('user', JSON.stringify(payload));
          dispatch({
            type: SET_USER,
            payload,
          });
          void loadTossOnboardingStatus(payload);

          const pathname = location.pathname.replace('/admin', '');
          if (pathname.includes('login')) {
            navigate(`${BASE_URL}/`);
          }
        } else {
          document.cookie = `a-token=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;`;
          if (channel) {
            channel.postMessage({
              type: 'logout',
            });
          }
        }
      } else {
        console.log(window.location);
      }
      onSubmit();
    }
  };

  return <Loading isLogo={true} />;
};

export default LayoutAuth;
